import * as React from "react";
import { Paper, Typography } from "@material-ui/core";
import { SketchPicker } from "react-color";
import Shibafu from "./shibafu";
import Canvas from "./canvas";

interface IProps {}

interface IState extends React.ComponentState {
  faceColor: string;
  hairColor: string;
  eyeColor: string;
  entityColor: string;
}

const styles = {
  root: {
    display: "flex",
    paddingLeft: "0.5rem"
  },
  paper: {
    margin: "0 0.5rem 0.5rem 0",
    padding: "0.5rem"
  }
};

export default class Generator extends React.Component<IProps, IState> {
  private canvasComponentRef: React.Ref<Canvas>;

  constructor(props: IProps, state: IState) {
    super(props, state);

    this.state = {
      faceColor: "#ffeac6",
      hairColor: "#00ffff",
      eyeColor: "#ffffff",
      entityColor: "#ffffff"
    };

    this.canvasComponentRef = React.createRef();
  }

  public render() {
    return (
      <div style={styles.root}>
        <div>
          <Paper style={styles.paper}>
            <Typography variant="h5" component="h3">
              顔
            </Typography>
            <SketchPicker
              color={this.state.faceColor}
              onChangeComplete={color =>
                this.setState({
                  faceColor: color.hex
                })
              }
            />
          </Paper>
          <Paper style={styles.paper}>
            <Typography variant="h5" component="h3">
              髪
            </Typography>
            <SketchPicker
              color={this.state.hairColor}
              onChangeComplete={color =>
                this.setState({
                  hairColor: color.hex
                })
              }
            />
          </Paper>
        </div>
        <div>
          <Paper style={styles.paper}>
            <Typography variant="h5" component="h3">
              目
            </Typography>
            <SketchPicker
              color={this.state.eyeColor}
              onChangeComplete={color =>
                this.setState({
                  eyeColor: color.hex
                })
              }
            />
          </Paper>
          <Paper style={styles.paper}>
            <Typography variant="h5" component="h3">
              実体
            </Typography>
            <SketchPicker
              color={this.state.entityColor}
              onChangeComplete={color =>
                this.setState({
                  entityColor: color.hex
                })
              }
            />
          </Paper>
        </div>
        <div>
          <Paper
            style={{
              padding: 0,
              margin: 0,
              marginRight: "0.5rem",
              width: 512,
              height: 512,
              overflow: "hidden"
            }}
          >
            <Shibafu
              canvasComponentRef={this.canvasComponentRef}
              hairColor={this.state.hairColor}
              faceColor={this.state.faceColor}
              eyeColor={this.state.eyeColor}
              entityColor={this.state.entityColor}
            />
          </Paper>
          <p>※ 作成した画像は右クリ保存で</p>
          <p>
            ソース:
            <a href="https://codesandbox.io/s/sibahu-ji49i">
              https://codesandbox.io/s/sibahu-ji49i
            </a>
          </p>
          <p>
            素材:
            <a href="https://social.mikutter.hachune.net/@shibafu528/102457430317019141">
              https://social.mikutter.hachune.net/@shibafu528/102457430317019141
            </a>
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/generator.tsx